import { render, staticRenderFns } from "./FabricDeliveries.vue?vue&type=template&id=0bb9c32e&scoped=true"
import script from "./FabricDeliveries.vue?vue&type=script&lang=js"
export * from "./FabricDeliveries.vue?vue&type=script&lang=js"
import style0 from "./FabricDeliveries.vue?vue&type=style&index=0&id=0bb9c32e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bb9c32e",
  null
  
)

export default component.exports